import { render } from "./TopCustomerChart.vue?vue&type=template&id=ea59ade8&scoped=true&ts=true"
import script from "./TopCustomerChart.vue?vue&type=script&lang=ts"
export * from "./TopCustomerChart.vue?vue&type=script&lang=ts"

import "./TopCustomerChart.vue?vue&type=style&index=0&id=ea59ade8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea59ade8"]])

export default __exports__